/**
 * Obscurable Navigation
 * @original-idea Kate York
 * @original-idea Oliver Boermans
 * @author Zenobius Jiricek
 *
 * @example
 * see ./header.scss
 */


//
// Utilities
import $ from 'jquery';

import debug from 'debug';
import plugin from '@core/plugins/lib';
import { selectTarget } from '@core/plugins/lib/selectors';

const PLUGIN_NAME = "ObscurableNavigation";
const ELEMENT_SELECTOR = "[data-navigation-obscurable]";
const log = debug('core/components/site-header/navigation--obscurable');


class ObscurableNavigationPlugin {

  constructor(element, options = {}) {

    this.element = element;
    this.$element = $(element);
    this.options = options;
    this.options.tolerancePx = parseInt(this.options.tolerancePx);

    log('created', {element, options: this.options});
    this.components = {
      obscuredItemContainer: selectTarget(this.options.obscuredItemContainerSelector, this.$element),
      visibleItemContainer: selectTarget(this.options.visibleItemContainerSelector, this.$element),
      obscuredItemContainerToggle: selectTarget(this.options.obscuredItemContainerToggleSelector, this.$element)
    };

    this.watch();

  }

  watch () {
    log('watch');
    this.currentTestId = 0;
    $(window).resize(() => {
      this.components.visibleItemContainer.addClass('testing');
    });
    $(window).resize(this.fn.debounce(this.test.bind(this), this.options.testTimeoutMs, true));
    $(window).resize(this.fn.debounce(this.test.bind(this), this.options.testTimeoutMs));
    setTimeout(this.test.bind(this), this.options.testTimeoutMs);
  }

  test () {
    log('test');
    this.unObscureItems();
    this.testItems();
  }

  isItemObscured (element) {
    log('isItemObscured', element);
    const $testElement = $(element);
    const width = $testElement.outerWidth(true);
    const rightEdgePosition = width + this.options.tolerancePx + this.accumulatedWidth;
    const result = rightEdgePosition > this.actualContainerWidth;
    log('isItemObscured', rightEdgePosition, this.actualContainerWidth, result);
    this.accumulatedWidth += width;
    return result;
  }

  unObscureItems() {
    log('unObscureItems');
    // Put everything back in main nav
    // to prepare for testing if they in fact fit.
    selectTarget(this.options.intersectingItemSelector, this.components.obscuredItemContainer)
      .removeClass(this.options.obscuredItemClasses)
      .addClass(this.options.visibleItemClasses)
      .each((index, element) => {
        this.components.visibleItemContainer.append($(element).detach());
      });
  }

  moveItem (element) {
    log('moveItem', element);
    const $element = $(element).detach();

    $element
      .addClass(this.options.obscuredItemClasses)
      .removeClass(this.options.visibleItemClasses);

    this.components.obscuredItemContainer
      .append($element);

    $element.show();
  }

  testItems (items) {
    log('testItems');
    const toggleWidth = this.components.obscuredItemContainerToggle.innerWidth();
    this.components.obscuredItemContainerToggle.detach();

    // Move the items that don't fit back to mobile nav
    this.components.obscuredItemContainerToggle.show();
    const $items = selectTarget(this.options.intersectingItemSelector, this.components.visibleItemContainer);
    log('testItems.items', $items);

    this.actualContainerWidth = this.components.visibleItemContainer.innerWidth();
    // build a list of items that don't fit
    this.accumulatedWidth = 0;
    let obscuredItems = $items.filter((index, element) => this.isItemObscured(element));
    log('testItems.obscuredItems', obscuredItems);

    // if at least one item doesn't fit
    if (!this.components.visibleItemContainer.is(':visible')) {
      $items.each((index, element) => this.moveItem(element));
    }

    else if (obscuredItems.length > 0) {
      // reduce width of container
      this.actualContainerWidth = this.actualContainerWidth - toggleWidth;
      log('testItems.atLeatOneObscured', this.actualContainerWidth);

      this.accumulatedWidth = 0;
      obscuredItems = $items
        // re-test visible items based on new container width
        .filter((index, element) => this.isItemObscured(element))
        // then move them
        .each((index, element) => this.moveItem(element));

    }

    if (obscuredItems.length > 0 || obscuredItems.length == $items.length ) {
      this.components.visibleItemContainer
        .append(this.components.obscuredItemContainerToggle);
    }

    if (!this.components.obscuredItemContainer.children().length > 0) {
      this.components.obscuredItemContainerToggle.hide();
    }

    this.components.visibleItemContainer.removeClass('testing');
  }

}


ObscurableNavigationPlugin.DEFAULTS = {
  tolerancePx: 40,
  testTimeoutMs: 150,
  reflowOnResize: true,
  visibleItemClasses: 'navigation__item--unobscured',
  obscuredItemClasses: 'navigation__item--obscured',
  visibleItemContainerSelector: '(children) [data-navigation--visible-items]',
  intersectingItemSelector: '(children) [data-navigation--intersecting-item]',
  obscuredItemContainerSelector: '(children) [data-navigation--obscured-items]',
  obscuredItemContainerToggleSelector: '(children) [data-navigation--obscured-items-toggle]',
};

plugin(PLUGIN_NAME, ObscurableNavigationPlugin);

$(document).ready(() => {
  $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./project/client/src/core/components/site-header/navigation--obscurable.js